import React from "react";
import { PropertyBrowserBaseStore } from "./PropertyBrowserBaseStore";
import { organisationPropertyBrowserStore } from "./OrganisationPropertyBrowserStore";

export const PropertyBrowserStoreContext =
  React.createContext<PropertyBrowserBaseStore>(
    organisationPropertyBrowserStore
  );

export function usePropertyBrowserStore(): PropertyBrowserBaseStore {
  return React.useContext(PropertyBrowserStoreContext);
}
